import styled from "styled-components";

export const CheckboxAndTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;

  &:not(:last-child) {
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid #e8e9ec;
  }
`;

export const AgreementsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

export const ConsentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ConsentRow = styled.div`
  padding: 14px 16px;
  border: 1px solid ${({ $hasError }) => $hasError ? "#e6000f" : "#e8e9ec"};
  border-radius: 8px;
  background: #f6f8f9;
  font-size: 12px;
  line-height: 20px;
  color: #111827;
  overflow-wrap: anywhere;

  > div {
    margin-top: 0;
  }

  label {
    gap: 8px;
    width: 100%;
    cursor: pointer;
  }

  input {
    appearance: none;
    position: relative;
    width: 14px;
    height: 14px;
    min-width: 14px !important;
    flex: 0 0 14px;
    margin: 3px 0 0;
    border: 1px solid #dce2e7;
    border-radius: 3px;
    background: #fff;
    cursor: pointer;
  }

  input:checked {
    border-color: #008b75;
    background: #008b75;
  }

  input:checked::after {
    content: "";
    position: absolute;
    top: 1px;
    left: 4px;
    width: 4px;
    height: 7px;
    border: solid #fff;
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }

  input:focus-visible {
    outline: 2px solid #008b75;
    outline-offset: 3px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const AgreementBody = styled.div`
  min-width: 0;
  max-height: 320px;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  padding: 20px;
  border: 1px solid #e8e9ec;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #374151;
  overflow-wrap: anywhere;

  strong,
  b {
    font-weight: 700;
  }

  p + p,
  ul,
  ol {
    margin-top: 12px;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  a {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid #008b75;
    outline-offset: 2px;
  }

  @media (max-width: 480px) {
    max-height: 240px;
    padding: 12px;
  }
`;

export const AgreementButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e8e9ec;

  button {
    letter-spacing: 0;
  }

  @media (max-width: 480px) {
    gap: 12px;

    button {
      flex: 1;
      min-width: 0;
      max-width: none;
    }
  }
`;
